import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import { disponibiliteFaceNumeriqueGetter } from '@/services/catalogue/disponibiliteFaceNumeriqueGetter';

function reducerDispo(acc, val) {
  switch (val) {
    case niveauDispo.DISPONIBLE:
      return acc + 1;
    case niveauDispo.PARTIELLEMENT_DISPONIBLE:
      return acc + 0.5;
    case niveauDispo.NON_DISPONIBLE:
    default:
      return acc;
  }
}

export default function decorateurRectanglePanneauxNumeriquesSemaine(rectangle, facesArray,
  dateStart, dateEnd) {
  const dispoArray = facesArray.map(el => disponibiliteFaceNumeriqueGetter(el, dateStart, dateEnd));
  const niveauMaxDispoPanneau = Math.max(...dispoArray);
  const niveauMinDispoPanneau = Math.min(...dispoArray);
  let niveauDispoPanneau = niveauDispo.PARTIELLEMENT_DISPONIBLE;
  if (niveauMinDispoPanneau === niveauDispo.DISPONIBLE) {
    niveauDispoPanneau = niveauDispo.DISPONIBLE;
  }
  if (niveauMaxDispoPanneau === niveauDispo.NON_DISPONIBLE) {
    niveauDispoPanneau = niveauDispo.NON_DISPONIBLE;
  }
  const nombreSpotsDisponibles = dispoArray.reduce(reducerDispo, 0);
  rectangle.texte = false;
  rectangle.widthOccupation = false;
  switch (niveauDispoPanneau) {
    case niveauDispo.NON_DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      rectangle.fill = niveauDispo.COULEUR_DISPO_INDISPONIBLE;
      break;
    case niveauDispo.PARTIELLEMENT_DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      rectangle.fill = niveauDispo.COULEUR_BLANCHE;
      rectangle.texte = nombreSpotsDisponibles + ' / ' + dispoArray.length;
      rectangle.widthOccupation =
        rectangle.widthWithPadding * (dispoArray.length - nombreSpotsDisponibles)
        / dispoArray.length;
      ['widthOccupation'].forEach((key) => {
        rectangle[key + 'String'] = rectangle[key] + '%';
      });
      rectangle.colorOccupation = niveauDispo.COULEUR_DISPO_PARTIELLEMENT;
      break;
    case niveauDispo.DISPONIBLE:
      rectangle.stroke = niveauDispo.COULEUR_DISPO_DISPONIBLE;
      rectangle.fill = niveauDispo.COULEUR_BLANCHE;
      break;
    case niveauDispo.DISPONIBILITE_INDEFINI:
    default:
      rectangle.stroke = niveauDispo.COULEUR_BLANCHE;
      rectangle.fill = niveauDispo.COULEUR_BLANCHE;
      break;
  }
}



// WEBPACK FOOTER //
// ./src/services/decorateur/decorateurRectanglePanneauxNumeriquesSemaine.js